import { useMemo, useCallback } from 'react';

import { Stack, Button, TextField, InputAdornment } from '@mui/material';

import { useTranslate } from 'src/locales';
import { useAppDispatch } from 'src/store/store';

import Iconify from 'src/components/iconify';
import { TableProps } from 'src/components/table';
import CustomPopover, { usePopover } from 'src/components/custom-popover';


export type Props = {
  table?: TableProps;
  onFilters?: (value: string) => void;
  onAddMeeting?: () => void;
};

export default function MeetingTableToolbar({
  table,
  onFilters,
  onAddMeeting
}: Props) {

  const { t } = useTranslate();

  const dispatch = useAppDispatch();

  const actionsControl = usePopover();

  const handleFilterName = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      onFilters ? onFilters(event.target.value) : null,
    [onFilters]
  );

  const showActions = useMemo(() => !!onAddMeeting, [onAddMeeting]);

  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{
        xs: 'column',
        sm: 'row',
      }}
      sx={{
        p: 2.5,
        pr: { xs: 2.5, md: 1 },
        width: '100%',
      }}
    >
      {onFilters && (
        <TextField
          onChange={handleFilterName}
          placeholder={t('common.search')}
          name="search"
          sx={{
            minWidth: {
              xs: '100%',
              sm: '360px',
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            ),
          }}
        />
      )}
      <Stack
        sx={{ width: '100%' }}
        direction="row"
        justifyContent="flex-end"
        spacing={2}
        flexGrow={1}
      >
        {showActions && (
          <Button
            size="medium"
            onClick={actionsControl.onOpen}
            startIcon={<Iconify icon="solar:hamburger-menu-line-duotone" />}
            variant="outlined"
            sx={{ textWrap: 'nowrap', width: { xs: '100%', sm: 'unset' } }}
          >
            {t('common.actions')}
          </Button>
        )}

      </Stack>

      <CustomPopover
        open={actionsControl.open}
        onClose={actionsControl.onClose}
        arrow="top-right"
      >
        <Stack>
          {onAddMeeting && (
            <Button
              onClick={() => {
                actionsControl.onClose();
                onAddMeeting();
              }}
              startIcon={<Iconify icon="material-symbols:add" />}
              sx={{ justifyContent: 'flex-start', px: 2, py: 1 }}
            >
              {t('meetings.actions.create')}
            </Button>
          )}

        </Stack>
      </CustomPopover >

    </Stack >
  );
}